var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.hasCartItems)?_c('div',{staticClass:"vue-cart-badge badge"},[_vm._v("\n    "+_vm._s(_setup.cartItems)+"\n")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }